import React from 'react';
import MessageSectionInspector from './MessageSectionInspector';

function SpotifySectionInspector({ func, index, onUpdate }) {
  const handleMessageSectionUpdate = (_, updatedProps) => {
    onUpdate(index, {
      ...func.props,
      messageSection: updatedProps
    });
  };

  return (
    <div>
      <div style={{ marginTop: 24 }}>
        <h3>Spotify Playlist Message Section</h3>
        <MessageSectionInspector
          func={{ name: 'SpotifyMessageSection', props: func.props.messageSection || {} }}
          index={index}
          onUpdate={handleMessageSectionUpdate}
          hideIconBool={true}
        />
      </div>
    </div>
  );
}

export default SpotifySectionInspector;
